import EfCardCartLists from './EFCardCartLists';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';
import EfInfoSection from '@elem/ui/ef-info-section';
import { useLang } from '@/i18n';

export default function TheComp({ bundles }: any) {
    const { t } = useLang('theProduct.ListC');

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-m" />
            <EfInfoSection title={t('title')} />
            <EfCardCartLists items={bundles} list_name={t('title')} />
            <EfSpec className="spec-x" />
        </div>
    );
}
